module.exports = __webpack_public_path__ + "media/complexity-selector/essentials@2x-d7ceb45f.png";